import styled from 'styled-components';

import {
  Flex,
  SVG,
} from 'web-styled';

export const SubHead = styled(Flex).attrs({
  align: 'center',
  justify: 'flex-end',
  noPrint: true,
})`
  width: 100%;
  min-height: 52px;
  border-bottom: 1px solid #ededed;
  padding: 0 10px;
`;

export const Add = styled(Flex).attrs({
  align: 'center',
})`
  width: 25px;
  height: 25px;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
`;

export const PlusCircle = styled(SVG.PlusCircle).attrs(
  props => ({
    stroke: props.theme.colors.primary,
  }),
)``;
